import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toEuros } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';

const CardCompte = ({ AvaDetenues }) => (
    <Card Titre={CardCompte.titleName}>
        <div className="card-text mb-3">
            <p className="text-center">{`${toEuros(AvaDetenues, true)} €`}</p>
        </div>
        <div className="d-flex justify-content-center">
            {AvaDetenues > 0 ?
                <Link to="/MesInformations/DetailsAvance" className="btn btn-outline-primary mt-2 w-50">
                Détails
                </Link> : null }
        </div>
    </Card>
);
CardCompte.displayName = 'CardAvance';
CardCompte.titleName = 'Mon avance détenue';
CardCompte.requiredProps = [
    'AvaDetenues', // Solde du propriétaire
];

function mapStateToProps({
    ProStore: {
        Pro: { AvaDetenues },
    },
}) {
    return {
        AvaDetenues,
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardCompte));



// WEBPACK FOOTER //
// ./src/components/MesInfos/CardAvance.js